import {} from "react";

import { useToLocaleDayOfWeek } from "2g-intl";

import { useKonfiguracniParametry, useZadostiFaze } from "b2b/api/hooks";

export default function useFixniPozadavky() {
  const konfiguracniParametryLoader = useKonfiguracniParametry();
  const fazeLoader = useZadostiFaze();
  const { long: toLong } = useToLocaleDayOfWeek();

  const getForKey = key => ({
    openDay: toLong(
      parseInt(
        konfiguracniParametryLoader.getHodnotaByKod(
          `${key}_OTEVRENI_DEN_V_TYDNU`
        )
      )
    ),

    openHours: konfiguracniParametryLoader
      .getHodnotaByKod(`${key}_OTEVRENI_HODINA`)
      ?.padStart(2, "0"),

    closeDay: toLong(
      parseInt(
        konfiguracniParametryLoader.getHodnotaByKod(
          `${key}_UZAVRENI_DEN_V_TYDNU`
        )
      )
    ),

    closeHours: konfiguracniParametryLoader
      .getHodnotaByKod(`${key}_UZAVRENI_HODINA`)
      ?.padStart(2, "0")
  });

  return {
    loading: konfiguracniParametryLoader.loading || fazeLoader.loading,
    loaded: konfiguracniParametryLoader.loaded || fazeLoader.loaded,
    error: konfiguracniParametryLoader.error || fazeLoader.error,
    faze: fazeLoader.data,
    fazeObdobiFixni:
      konfiguracniParametryLoader.loaded && getForKey("FIXNI_POZADAVKY"),
    fazeObdobiVsechny:
      konfiguracniParametryLoader.loaded && getForKey("BEZNE_POZADAVKY")
  };
}
